import React from 'react';
import { connect } from 'react-redux';

import BaseComponent from '../../../baseClasses/BaseComponent';
import StateComboBox from '../../../components/StateComboBox';
import locationsService from '../../../services/locationsService.js';
import LocationHeader from './LocationHeader';
import MarketComboBox from '../../../components/MarketComboBox';
import dataModel from '../../../models/DataModel';
import LocationContact from './LocationContact';
import DataSource from '../../../dao/DataSource/DataSource';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import { location_root } from '../../../dao/LocationsDAO';
import { geocodeByPlaceId, getLatLng } from 'react-google-places-autocomplete';

import './LocationCRUD.scss';
import Input from '../../../components/Input/index.js';
import Textarea from '../../../components/Textarea/index.js';

export class LocationCRUD extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      displayHeight: 0,
      guidChanged: false,
      allMarketUsers: [],
      addressSuggestions: [],
      showSuggestions: false,
      selectedSuggestionIndex: -1,
    };

    this.renderLocationContacts = this.renderLocationContacts.bind(this);
    this.baseRoute = '/por/location/';
  }

  handleMarketsRetrieval(markets, action, acData, fetchedData){
    if (markets) {
      this.setState({ markets });
    }
  }

  handleUsersRetrieval(marketUsers, action, acData, fetchedData) {
    if (marketUsers) {
      this.setState({ allMarketUsers: marketUsers.users });
    }
  }

  handleLocationRetrieval(location, action, acData, fetchedData) {
    this.setState({ location });
    if (!this.state.editLocation || this.state.editLocation.id != location.id) {
      this.setState({ editLocation: location });
    }
    if (location.market && location.market.id) {
      this.usersDataSource = new CollectionDataSource('MarketUsersCollection', 'User', { user: {} }, this.handleUsersRetrieval, null, null, null, null, null, location.market.id);
      this.usersDataSource.current();
    }
  }

  handleInitializeDataSources() {
    if (this.marketsDataSource) {
      this.marketsDataSource.release();
      this.marketsDataSource = null;
    }
    if (this.usersDataSource) {
      this.usersDataSource.release();
      this.usersDataSource = null;
    }
    if (this.locationDataSource) {
      this.locationDataSource.release();
      this.locationDataSource = null;
    }
  
    this.marketsDataSource = new CollectionDataSource('MarketsCollection', 'Market', { market: {} }, this.handleMarketsRetrieval,
      this.props.currentUser.id, this.props.currentCompany.id);
    this.marketsDataSource.current();

    this.locationDataSource = new DataSource('Location', +this.props.params.location_id, location_root, this.handleLocationRetrieval);
    this.locationDataSource.get();
  }

  componentDidMount() {
    super.componentDidMount(this);
    
    if (this.props.currentCompany) {
      this.handleInitializeDataSources();
    }
  }

  componentWillUnmount() {
    if (this.marketsDataSource) {
      this.marketsDataSource.release();
      this.marketsDataSource = null;
    }
    if (this.usersDataSource) {
      this.usersDataSource.release();
      this.usersDataSource = null;
    }
    if (this.locationDataSource) {
      this.locationDataSource.release();
      this.locationDataSource = null;
    }
  }

  componentDidUpdate(prevProps){
    if (this.props.currentCompany != prevProps.currentCompany ||
      prevProps.params.location_id != this.props.params.location_id) {
      this.handleInitializeDataSources();
    }
  }

  handleChangeSiteName(e){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.name = e.target.value;
    this.setState({ editLocation: editedLocation, changed: true });
  }

  handleChangeGuid(e){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.guid = e.target.value;
    this.setState({ editLocation: editedLocation, changed: true, guidChanged: true });
  }

  handleMarketChange(market) {
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation, { market: market });
    if (this.usersDataSource) {
      this.usersDataSource.release();
    }
    this.setState({ editLocation: editedLocation, changed: true });
    this.usersDataSource = new CollectionDataSource('MarketUsersCollection', 'User', { user: {} }, this.handleUsersRetrieval, null, null, null, null, null, editedLocation.market.id);
    this.usersDataSource.current();  
  }

  handleChangeLatitude(e){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.latitude = e.target.value;
    this.setState({ editLocation: editedLocation, changed: true });
  }

  handleChangeLongitude(e){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.longitude = e.target.value;
    this.setState({ editLocation: editedLocation, changed: true });
  }

  handleChangeNotes(e){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.notes = e.target.value;
    this.setState({ editLocation: editedLocation, changed: true });
  }

  handleChangeCity(e){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.city = e.target.value;
    this.setState({ editLocation: editedLocation, changed: true });
  }

  handleChangeState(type, option){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.state = option.name;
    this.setState({ editLocation: editedLocation, changed: true });
  }

  handleChangeZip(e){
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.zip = e.target.value;
    this.setState({ editLocation: editedLocation, changed: true });
  }

  handleAddressInputChange = (e) => {
    const inputValue = e.target.value;
    
    // Update the address field
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);
    editedLocation.address = inputValue;
    this.setState({ editLocation: editedLocation, changed: true });

    // Fetch suggestions from Google Places
    this.fetchAddressSuggestions(inputValue);
  }

  fetchAddressSuggestions = async (input) => {
    if (!input || input.length < 3) {
      this.setState({ 
        addressSuggestions: [], 
        showSuggestions: false,
        selectedSuggestionIndex: -1,
      });
      return;
    }

    try {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.error('Google Maps API not loaded');
        return;
      }

      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions({
        input: input,
        types: ['address'],
        componentRestrictions: { country: 'us' },
      }, (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
          this.setState({
            addressSuggestions: predictions,
            showSuggestions: true,
            selectedSuggestionIndex: -1,
          });
        } else {
          this.setState({
            addressSuggestions: [],
            showSuggestions: false,
            selectedSuggestionIndex: -1,
          });
        }
      });
    } catch (error) {
      console.error('Error fetching address suggestions:', error);
      this.setState({
        addressSuggestions: [],
        showSuggestions: false,
        selectedSuggestionIndex: -1,
      });
    }
  }

  handleSuggestionSelect = async (suggestion) => {
    try {
      const results = await geocodeByPlaceId(suggestion.place_id);
      
      if (results && results.length > 0) {
        const result = results[0]; 
        const { lat, lng } = await getLatLng(result);
        this.populateLocationFromGooglePlace(result, lat, lng);
      }
    } catch (error) {
      console.error('Error fetching place details:', error);
    }

    this.setState({
      addressSuggestions: [],
      showSuggestions: false,
      selectedSuggestionIndex: -1,
    });
  }

  handleKeyDown = (e) => {
    const { addressSuggestions, selectedSuggestionIndex, showSuggestions } = this.state;

    if (!showSuggestions || addressSuggestions.length === 0) return;

    switch (e.key) {
    case 'ArrowDown':
      e.preventDefault();
      this.setState({
        selectedSuggestionIndex: Math.min(selectedSuggestionIndex + 1, addressSuggestions.length - 1),
      });
      break;
    case 'ArrowUp':
      e.preventDefault();
      this.setState({
        selectedSuggestionIndex: Math.max(selectedSuggestionIndex - 1, -1),
      });
      break;
    case 'Enter':
      e.preventDefault();
      if (selectedSuggestionIndex >= 0 && selectedSuggestionIndex < addressSuggestions.length) {
        this.handleSuggestionSelect(addressSuggestions[selectedSuggestionIndex]);
      }
      break;
    case 'Escape':
      this.setState({
        showSuggestions: false,
        selectedSuggestionIndex: -1,
      });
      break;
    }
  }

  populateLocationFromGooglePlace(placeDetails, lat, lng) {
    dataModel.dataChanged = true;
    let editedLocation = Object.assign({}, this.state.editLocation);

    // Extract address components
    const addressComponents = placeDetails.address_components || [];
    let streetNumber = '';
    let route = '';
    let city = '';
    let state = '';
    let zip = '';

    addressComponents.forEach(component => {
      const types = component.types;
      
      if (types.includes('street_number')) {
        streetNumber = component.long_name;
      } else if (types.includes('route')) {
        route = component.long_name;
      } else if (types.includes('locality')) {
        city = component.long_name;
      } else if (types.includes('administrative_area_level_1')) {
        state = component.short_name; // Use short name for state (e.g., "CA" instead of "California")
      } else if (types.includes('postal_code') || types.includes('postal_code_prefix') || types.includes('postal_code_suffix')) {
        zip = component.long_name;
      }
    });

    // If no city found, try to use county or other locality types
    if (!city) {
      addressComponents.forEach(component => {
        const types = component.types;
        if (types.includes('administrative_area_level_2') || types.includes('sublocality') || types.includes('sublocality_level_1')) {
          city = component.long_name;
        }
      });
    }

    // If ZIP code wasn't found in components, try to extract it from formatted address
    if (!zip && placeDetails.formatted_address) {
      // Try multiple ZIP code patterns
      const zipPatterns = [
        /\b\d{5}(-\d{4})?\b/,  // US ZIP: 12345 or 12345-6789
        /\b[A-Z]\d[A-Z] \d[A-Z]\d\b/,  // Canadian postal code: A1A 1A1
        /\b\d{5}\b/,  // Simple 5-digit ZIP
      ];
      
      for (const pattern of zipPatterns) {
        const zipMatch = placeDetails.formatted_address.match(pattern);
        if (zipMatch) {
          zip = zipMatch[0];
          break;
        }
      }
    }

    // Populate all location fields
    editedLocation.address = placeDetails.formatted_address || editedLocation.address;
    editedLocation.city = city || editedLocation.city;
    editedLocation.state = state || editedLocation.state;
    editedLocation.zip = zip || editedLocation.zip;
    
    // Set coordinates using the provided lat/lng
    editedLocation.latitude = lat.toString();
    editedLocation.longitude = lng.toString();

    // Set Google Place ID for future reference
    editedLocation.google_place_id = placeDetails.place_id;

    this.setState({ 
      editLocation: editedLocation, 
      changed: true,
      googlePlacesValue: null, // Clear the Google Places input
    });
  }

  handleFieldValidations(location) {
    let object = null;
    const lat = parseFloat(location.latitude);
    const long = parseFloat(location.longitude);
    let hasLatLong = !(isNaN(lat) || isNaN(long));

    let hasAddress =
      location.zip && location.zip.trim() != '' &&
      location.state && location.state.trim() != '' &&
      location.city && location.city.trim() != '' &&
      location.address && location.address.trim() != '';
    
    if (!hasLatLong && !hasAddress){
      object = {
        message: 'Please enter a complete address or a latitude and longitude',
        id: 'location-latitude',
      };
    }
    if (!location.market) {
      object = {
        message: 'Please add a market',
        id: 'location-market',
      };
    }
    if(!location.guid || location.guid.trim() == ''){
      object = {
        message: 'Please add a unique ID',
        id: 'location-guid',
      };
    }
    if (!location.name || location.name.trim() == ''){
      object = {
        message: 'Please add a ' + this.textMap.siteName,
        id: 'location-site-name',
      };
    }

    return object;
  }

  handleLocationValidation(location){
    let message = null;
    let id;
    let self = this;
    if(this.state.guidChanged){
      locationsService.checkLocationGUID(this.state.editLocation.guid).then(results => {
        if(results.message == 'location guid already exists'){
          message = 'Location ID already exists. Please choose another Location ID.';
          id = 'location-guid';
        }
        else{
          let obj = self.handleFieldValidations(location);
          if (obj) {
            message = obj.message;
            id = obj.id;
          }
        }
        if(message){
          dataModel.displayWarnErrorMessage(message, 4000, 2);
          if (id) {
            const element = document.getElementById(id);
            if (element) {
              element.focus();
            }
          }
          return false;
        }
        dataModel.locationsDAO.updateLocation(self.state.editLocation, { recordDescriptor: location_root });
        self.setState({ changed: false, guidChanged: false });
        self.handleCancelEditMode(self.state.editLocation);
      });
    }
    else{
      let obj = this.handleFieldValidations(location);
      if (obj) {
        message = obj.message;
        id = obj.id;
      }
      if(message){
        dataModel.displayWarnErrorMessage(message, 4000, 2);
        if(id){
          document.getElementById(id).focus();
        }
        return false;
      }
      return true;
    }
  }

  handleSaveLocation() {
    let validated = this.handleLocationValidation(this.state.editLocation);
    if (validated) {
      const invalidLocationContactIdsForMarket = this.getInvalidLocationContactIdsForMarket();
      if (invalidLocationContactIdsForMarket.length) {
        dataModel.showGlobalModal('SYSTEM_POPUP', {
          message: 'Changing the Market on this location will remove one or more of your Location Contacts who belong to a different Market.',
          captionText: 'WARNING',
          height: 220,
          width: 300,
          okButtonText: 'OK',
          handleOwnerOk: () => {
            for (let invalidContactId of invalidLocationContactIdsForMarket) {
              // remove invalid users as contacts
              dataModel.locationsDAO.deleteLocationUser(invalidContactId);
            }

            dataModel.locationsDAO.updateLocation(this.state.editLocation);
            this.setState({ changed: false, guidChanged: false });
            this.handleCancelEditMode(this.state.editLocation);
          },
        });
      }
      else {
        dataModel.locationsDAO.updateLocation(this.state.editLocation, { recordDescriptor: location_root }).then(location => {
          this.setState({ changed: false, guidChanged: false });
          this.handleCancelEditMode(location);
        });
      }
    }
  }

  getInvalidLocationContactIdsForMarket() {
    // See if we will be clearing any location contacts
    const marketUserIds = new Set();
    const invalidLocationContactIds = [];
    if (this.state.allMarketUsers) {
      for (let user of this.state.allMarketUsers) {
        marketUserIds.add(user.id);
      }
    }
    if (this.state.editLocation.location_users) {
      for (let locationContact of this.state.editLocation.location_users) {
        if(!marketUserIds.has(locationContact.user_id)) {
          // warn user if changing the market will clear one or more assigned contacts
          // note: user_id corresponds to the id of the User (same as market), but id corresponds to the LocationUser id
          invalidLocationContactIds.push(locationContact.id);
        }
      }
    }
    return invalidLocationContactIds;
  }

  /** Delete user from location-users list */
  handleDeleteLocationUser(locationUserId) {
    dataModel.locationsDAO.deleteLocationUser(locationUserId, this.state.editLocation.id).then(() => {
      const editLocationCopy = Object.assign({}, this.state.editLocation);
      const userToDeleteIndex = editLocationCopy.location_users.findIndex((locationUser) => {
        return locationUser.id == locationUserId;
      });
      editLocationCopy.location_users.splice(userToDeleteIndex, 1);
      //update state
      this.setState({ editLocation: editLocationCopy });
    });
  }

  /** Add or update user in location-users list */
  handleSaveLocationUser(locationUserId, editedContact) {
    const newUser = locationUserId ? false : true;
    if (newUser) {
      editedContact.locationId = this.state.editLocation.id;
      dataModel.locationsDAO.createLocationUser(editedContact).then((createdLocationUser) =>{
        if (createdLocationUser) {
          let editLocationCopy = Object.assign({}, this.state.editLocation);
          if (!editLocationCopy.location_users) {
            editLocationCopy.location_users = [];
          }
          editLocationCopy.location_users.push(createdLocationUser);
          this.setState({ editLocation: editLocationCopy });
        }
      });
    }
    else {
      dataModel.locationsDAO.updateLocationUser(editedContact).then((updatedLocationUser) =>{
        const editLocationCopy = Object.assign({}, this.state.editLocation);
        if (updatedLocationUser) {
          if (!editLocationCopy.location_users) {
            editLocationCopy.location_users = [];
            editLocationCopy.location_users.push(updatedLocationUser);
          }
          else {
            editLocationCopy.location_users = editLocationCopy.location_users.map(locUser => {
              if (locUser.id == updatedLocationUser.id) {
                return updatedLocationUser;
              }
              else{
                return locUser;
              }
            });
            this.setState({ editLocation: editLocationCopy });
          }
        }
      });
      
    }
  }

  handleClearLocation(){
    this.setState({ editLocation: null, changed: false, guidChanged: false });
    this.handleCancelEditMode(this.state.location);
  }

  handleCancelEditMode(location) {
    dataModel.dataChanged = false;
    if (this.props.history.savedLocation) {
      this.props.history.replace(this.props.history.savedLocation);
      this.props.history.clearSavedLocation();
    }
    else {
      this.props.history.push(this.baseRoute + location.id + '/project/all');
    }
  }

  handleExpansion(height){
    this.setState({ displayHeight: height });
    this.handleSubHeaderExpand(height);
    if(this.props.handleMapExpanded){
      this.props.handleMapExpanded(height > 0 ? true : false);
    }
  }

  handleSubHeaderExpand(expandAmount, animatorGroup, time) {
    if (animatorGroup) {
      const startHeight = window.innerHeight - this.state.scrollHeightDiffFromHeader;
      const endHeight = window.innerHeight - 18;
      const ani1 = this.animator.createPropertyAnimation('project-detail-scroller', time,
        { height: { startVal: startHeight, endVal: endHeight } });
      animatorGroup.push(ani1);
      const ani2 = this.animator.createPropertyAnimation('project-detail', time,
        { height: { startVal: startHeight, endVal: endHeight } });
      animatorGroup.push(ani2);
    }
    else {
      this.setState({ scrollHeightDiffFromHeader: expandAmount });
    }
  }

  getUnassignedMarketUsers(marketUsers) {
    const assignedUserIds = new Set();
    if (this.state.editLocation.location_users) {
      for (let locationContact of this.state.editLocation.location_users) {
        if (locationContact.user) {
          assignedUserIds.add(locationContact.user.id);
        }
        else if (locationContact.firstName) {
          assignedUserIds.add(locationContact.user.id);
        }
      }
    }
    if (marketUsers) {
      return marketUsers.filter((marketUser) => {
        return (!assignedUserIds.has(marketUser.id));
      });
    }
    return [];
  }

  renderLocationContacts() {
    let contactList = [];
    const unassignedMarketUsers = this.getUnassignedMarketUsers(this.state.allMarketUsers);
    const locationUsers = this.state.editLocation.location_users || this.state.location.location_users;
    if(locationUsers && locationUsers.length) {
      for (let locationContact of locationUsers) {
        // add selected to options list
        const locationMarketUsers = Object.assign([], unassignedMarketUsers);
        locationMarketUsers.push(locationContact.user);
        
        contactList.push(
        <LocationContact 
            key={'location-contact-'+locationContact.id}
            contact={locationContact} 
            locationMarketUsers={locationMarketUsers} 
            handleDeleteLocationUser={this.handleDeleteLocationUser} 
            handleSaveLocationUser={this.handleSaveLocationUser} />
        );
      }
    }
    if ((!locationUsers || locationUsers.length < 2) && unassignedMarketUsers) {
      //maximum of 2 key contacts
      const randomId = Math.floor(Math.random() * 1000);
      const newContact = (
        <LocationContact
          key={'location-contact-new' + randomId}
          locationMarketUsers={unassignedMarketUsers} 
          handleDeleteLocationUser={this.handleDeleteLocationUser}
          handleSaveLocationUser={this.handleSaveLocationUser} />
      );
      contactList.push(newContact);
    }

    return (
      <div className="locations-view-column locations-view-column--contacts">
        <div className="caption">Location Contacts</div>
        <div className='location-contacts-container'>
          {contactList}
        </div>
      </div>
    );
  }

  handleCreateEditView(location){
    const stateOption = location ? { type: location.state, name: location.state } : null;
    let locationContacts;
    const { permissions } = this.props;
    if (permissions.canCreateLocationUsers || permissions.canEditLocationUsers || permissions.canDeleteLocationUsers) {
      locationContacts = this.renderLocationContacts();
    }
    return (
      <div className="locations-view-container" style={{ marginTop: this.state.displayHeight + 25 }}>
        <div className="locations-view-column locations-view-column--metadata">
          <div className="caption">{this.textMap.projectLocation}</div>
          <div className="location-entry-container">
            <div className="location-entry-field">
              <div className="location-label">{this.textMap.siteName.toUpperCase()}</div>
              <Input id='location-site-name' className="field" value={location.name || ''} onChange={this.handleChangeSiteName}/>
            </div>
            <div className="location-entry-field">
              <div className="location-label">{this.textMap.locationId.toUpperCase()}</div>
              <Input id='location-guid' className="field" value={location.guid || ''} onChange={this.handleChangeGuid}
                onKeyDown={this.handleKeyboardLocationSearch} />
            </div>
            <div className="location-entry-field" style={{ height: 'auto' }}>
              <div className="location-label">{this.textMap.address.toUpperCase()}</div>
              <div style={{ position: 'relative' }}>
                <Input 
                  id='location-address' 
                  className="field" 
                  value={location.address || ''} 
                  onChange={this.handleAddressInputChange}
                  onKeyDown={this.handleKeyDown}
                  placeholder="Type an address or select from suggestions..."
                  style={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', textIndent: '4px' }}
                />
                {this.state.showSuggestions && this.state.addressSuggestions.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    backgroundColor: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                    maxHeight: '200px',
                    overflowY: 'auto',
                  }}>
                    {this.state.addressSuggestions.map((suggestion, index) => (
                      <div
                        key={suggestion.place_id}
                        onClick={() => this.handleSuggestionSelect(suggestion)}
                        style={{
                          padding: '8px 12px',
                          cursor: 'pointer',
                          backgroundColor: index === this.state.selectedSuggestionIndex ? '#e3f2fd' : 'white',
                          borderBottom: index < this.state.addressSuggestions.length - 1 ? '1px solid #eee' : 'none',
                          fontSize: '12px',
                          fontFamily: 'Open Sans',
                        }}
                        onMouseEnter={() => this.setState({ selectedSuggestionIndex: index })}
                      >
                        <div style={{ fontWeight: 'bold', color: '#000' }}>
                          {suggestion.structured_formatting.main_text}
                        </div>
                        <div style={{ color: '#666', fontSize: '11px' }}>
                          {suggestion.structured_formatting.secondary_text}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="location-entry-field">
              <div className="location-label">{this.textMap.markets.toUpperCase()}</div>
              <div className="field combobox-field" id="markets">
                <MarketComboBox
                  handleMenuSelection={this.handleMarketChange}
                  id="location-market"
                  height={24}
                  width={240}
                  hasBorder={false}
                  multiSelect={false}
                  defaultText={this.textMap.markets}
                  markets={this.state.markets}
                  displayFontStyle={{ fontSize: '12px', fontFamily: 'Open Sans', color: '#000000', textIndent: '4px' }}
                  currentOption={location.market}
                />
                </div>
            </div>
            <div className="location-double-entry-field">
              <div className="location-half-field">
                <div className="location-label">{this.textMap.latitude.toUpperCase()}</div>
                <Input id='location-latitude' className="field" value={location.latitude ? location.latitude : ''} onChange={this.handleChangeLatitude} />
              </div>
              <div className="location-half-field">
                <div className="location-label">{this.textMap.longitude.toUpperCase()}</div>
                <Input id='location-longitude' className="field" value={location.longitude ? location.longitude : ''} onChange={this.handleChangeLongitude} />
              </div>
            </div>
            <div className="location-entry-field">
              <div className="location-label">{this.textMap.city.toUpperCase()}</div>
              <Input id='location-city' className="field" value={location.city || ''} onChange={this.handleChangeCity} />
            </div>
            <div className="location-double-entry-field">
              <div className="location-half-field ">
                <div className="location-label">{this.textMap.state.toUpperCase()}</div>
                <div className='field combobox-field' id='state'>
                  <StateComboBox
                    id={'statePicker'}
                    currentOption={stateOption}
                    hasBorder={false}
                    underlined={false}
                    width={114}
                    height={24}
                    displayFontStyle={{ fontSize: '12px', color: '#000000', textIndent: '4px' }}
                    handleStateChange={this.handleChangeState}
                    placeHolderText={this.textMap.state}
                    top={32}
                  />
                  </div>
              </div>
              <div className="location-half-field">
                <div className="location-label">{this.textMap.zip.toUpperCase()}</div>
                <Input id='location-zip' className="field" value={location.zip || ''} onChange={this.handleChangeZip}/>
              </div>
            </div>
            <div className="location-entry-field location-entry-field--notes">
              <div className="location-label">{this.textMap.locationNotes.toUpperCase()}</div>
              <Textarea id='location-notes' className="field location-text-area" value={location.notes || ''} onChange={this.handleChangeNotes} />
            </div>
          </div>
        </div>
      
        {locationContacts}
      </div>
    
    );
  }

  handleDeleteLocation(location) {
    if (this.locationDataSource) {
      this.locationDataSource.delete();
      this.props.history.push(this.baseRoute);
    }
  }

  render() {
    const { closeMap } = this.props;
    const editLocation = this.state.editLocation;
    if (!editLocation){
      return null;
    }

    let scrollerHeight = window.innerHeight - 76 - 60;
    let view = this.handleCreateEditView(editLocation);
    return <div className='view-container' id={this.props.id}>
      <LocationHeader
        editLocation={editLocation}
        handleExpansion={this.handleExpansion}
        type='locations-page'
        handleSaveLocation={this.handleSaveLocation}
        handleCancelLocationEdit={this.handleClearLocation}
        changed={this.state.changed}
        closeMap={closeMap}
        closeDropdown={this.props.handleCloseDropdown}
        editing={true}
        deleteLocation={this.handleDeleteLocation}
       />
       <div className='location-view-scroller'style={{ height: scrollerHeight }}>
        {view}
      </div>
    </div>;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataChanged: state.main.dataChanged,
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(LocationCRUD);



// WEBPACK FOOTER //
// ./src/containers/PORContainer/LocationCRUD/index.js